<template>
    <CommonList
            selection-type="radio"
            row-key="userId"
            :has-more-search="true"
            :auto-load="true"
            ref="listRef"
            cellOverflow="ellipsis"
            @selection-change="handleSelectionChange"
            @current-row-change="handleCurrentRowChange"
            @load-start="handleLoadList"
            @search-click="handleLoadList"
            @pagination-change="handleLoadList"
            @reset-click="handleReset"
    >
        <!-- 固定搜索区 -->
        <template #search-item-fixed>
            <div class="common-search-item">
                <label class="common-search-label80">用户ID：</label>
                <el-input v-model="searchForm.userId" class="common-input120" placeholder="请输入用户ID"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">用户名称：</label>
                <el-input v-model="searchForm.userName" class="common-input120" placeholder="请输入用户名称"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">用户生效：</label>
                <el-select v-model="searchForm.isDeleted" class="common-input100" placeholder="请选择">
                    <el-option label="是" value="0"></el-option>
                    <el-option label="否" value="1"></el-option>
                </el-select>
            </div>
        </template>

        <!-- 展开搜索区 -->
        <template #search-item-expand>
            <div class="common-search-item">
                <label class="common-search-label80">手机号：</label>
                <el-input v-model="searchForm.phoneNumber" class="common-input120" placeholder="请输入手机号"></el-input>
            </div>
            <div class="common-search-item">
                <label class="common-search-label80">邮箱：</label>
                <el-input v-model="searchForm.email" class="common-input120" placeholder="请输入邮箱"></el-input>
            </div>

<!--            <div class="common-search-item">-->
<!--                <label class="common-search-label80">创建时间：</label>-->
<!--                <el-date-picker-->
<!--                        v-model="searchForm.createTime"-->
<!--                        type="date"-->
<!--                        placeholder="请选择创建时间"-->
<!--                        class="common-date150"-->
<!--                ></el-date-picker>-->
<!--            </div>-->
<!--            <div class="common-search-item">-->
<!--                <label class="common-search-label80">更新时间：</label>-->
<!--                <el-date-picker-->
<!--                        v-model="searchForm.updateTimeRange"-->
<!--                        type="datetimerange"-->
<!--                        range-separator="至"-->
<!--                        start-placeholder="开始时间"-->
<!--                        end-placeholder="结束时间"-->
<!--                        format="YYYY-MM-DD"-->
<!--                        value-format="YYYY-MM-DD"-->
<!--                        class="common-date300"-->
<!--                ></el-date-picker>-->
<!--            </div>-->
        </template>

        <!-- 操作按钮 -->
        <template #btn-group>
<!--            <el-button type="primary" class="list-btn" @click="handleAdd">-->
<!--                <el-icon>-->
<!--                    <Plus/>-->
<!--                </el-icon>-->
<!--                新增用户-->
<!--            </el-button>-->
            <el-button
                    type="warning"
                    class="list-btn"
                    @click="handleEdit"
                    :disabled="!selectedRow"
            >
                <el-icon>
                    <Edit/>
                </el-icon>
                修改用户
            </el-button>
            <el-button
                    type="danger"
                    class="list-btn"
                    @click="handleDelete"
                    :disabled="!selectedRow || selectedRow?.isDeleted === 0"
            >
                <el-icon>
                    <Delete/>
                </el-icon>
                删除用户
            </el-button>
            <el-button
                    type="primary"
                    class="list-btn"
                    @click="handleSetInspector"
                    :disabled="!selectedRow || selectedRow?.isDeleted === 1"
            >
                设置检车员
            </el-button>
        </template>

        <!-- 表格列 width="auto" 占剩余宽度 :resizable="false" 不可拖拽-->
        <template #table-column>
            <el-table-column prop="userId" label="用户ID" align="center" width="120"></el-table-column>
            <el-table-column prop="userName" label="用户名称" align="center" width="180"></el-table-column>
            <el-table-column prop="registrationMethod" label="注册方式" align="center" min-width="120"></el-table-column>
            <el-table-column prop="phoneNumber" label="手机号" align="center" min-width="120"></el-table-column>
            <el-table-column prop="email" label="邮箱" align="center" min-width="160"></el-table-column>
            <el-table-column prop="isDeleted" label="是否生效" align="center" width="100">
                <template #default="scope">
                    <el-tag :class="scope.row.isDeleted === 0 ? 'list-status-normal' : 'list-status-deleted'">
                        {{ scope.row.isDeleted === 0? '是' : '否' }}
                    </el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="lastLoginTime" label="最后登录时间" align="center" min-width="180"
                 :formatter="(row) => $formatTime(row.lastLoginTime)"
            ></el-table-column>

            <el-table-column label="配置角色" align="center" width="100" :resizable="false">
                <template #default="scope">
                    <el-button
                            type="primary"
                            size="small"
                    :disabled="scope.row.isDeleted !== 0"
                    @click="configuration(scope.row)">
                    配置
                    </el-button>
                </template>
            </el-table-column>
        </template>

        <!-- 新增/编辑弹窗 -->
        <template #extra>
            <el-dialog
                    v-model="dialogVisible"
                    :title="dialogType === 'add' ? '新增用户' : '修改用户'"
                    width="800px"
                    destroy-on-close
            >
                <el-form
                        ref="formRef"
                        :model="formData"
                        :rules="formRules"
                        label-width="100px"
                        class="list-modal-form"
                >
                    <el-form-item label="用户ID" prop="userId">
                        <el-input
                                v-model="formData.userId"
                                :disabled= true
                                placeholder="请输入用户ID"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="用户名称" prop="userName">
                        <el-input
                                v-model="formData.userName"
                                placeholder="请输入用户名称"
                                maxlength="20"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phoneNumber">
                        <el-input
                                v-model="formData.phoneNumber"
                                placeholder="请输入11位有效手机号"
                                maxlength="11"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="邮箱" prop="email">
                        <el-input
                                v-model="formData.email"
                                placeholder="请输入邮箱地址"
                                maxlength="100"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="微信">
                        <el-input
                                v-model="formData.wechat"
                                placeholder="暂无微信"
                                disabled
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="是否生效" prop="isDeleted">
                        <el-radio-group v-model="formData.isDeleted">
                            <el-radio :label="0">是</el-radio>
                            <el-radio :label="1">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
                
                <!-- 公司信息管理 -->
                <div style="margin-top: 20px; border-top: 1px solid #e6e6e6; padding-top: 20px;">
                    <div style="margin-bottom: 10px;">
                        <span style="font-weight: bold;">公司信息</span>
                    </div>
                    
                    <!-- 已绑定公司或已选择公司时显示详情 -->
                    <div v-if="formData.companyId || selectedCompanyId" style="display: flex; gap: 10px; align-items: center;">
                        <div style="background-color: #f5f7fa; padding: 12px 20px; border-radius: 4px; flex: 1;">
                            <span style="font-weight: bold;">已绑定公司：</span>
                            <span style="margin-left: 10px;">{{ selectedCompanyDetail?.companyName }}</span>
                            <span style="margin-left: 20px; color: #909399;">（小程序编码：{{ selectedCompanyDetail?.miniProgramCode }}）</span>
                        </div>
                        <el-button type="danger" @click="handleUnbindCompany" v-if="formData.companyId">解除绑定</el-button>
                    </div>
                    
                    <!-- 未绑定公司时 -->
                    <div v-else style="display: flex; gap: 10px; align-items: center;">
                        <div style="background-color: #f5f7fa; padding: 12px 20px; border-radius: 4px; flex: 1;">
                            <span style="color: #909399;">未绑定公司</span>
                        </div>
                        <el-button type="primary" @click="openCompanySelectDialog">绑定公司</el-button>
                    </div>
                </div>

                <!-- 公司选择弹窗 -->
                <el-dialog v-model="companySelectDialogVisible" title="选择公司" width="500px" destroy-on-close>
                    <el-select v-model="tempSelectedCompanyId" placeholder="请选择公司" style="width: 100%;" clearable @change="handleCompanySelect">
                        <el-option v-for="company in allCompanyList" :key="company.companyId" :label="company.companyName" :value="company.companyId"></el-option>
                    </el-select>
                    <template #footer>
                        <div style="text-align: center; width: 100%;">
                            <el-button @click="cancelCompanySelectDialog">取消</el-button>
                            <el-button type="primary" @click="confirmCompanySelect">确定</el-button>
                        </div>
                    </template>
                </el-dialog>

                <template #footer>
                    <div style="text-align: center; width: 100%;">
                        <el-button @click="dialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="handleSubmit">确定</el-button>
                    </div>
                </template>
            </el-dialog>



            <el-dialog
                    v-model="configRoleDialogVisible"
                    title="角色配置"
                    width="600px"
                    destroy-on-close
            >
                <el-tree
                        ref="roleTreeRef"
                        :data="roleTreeData"
                        :props="treeProps"
                        show-checkbox
                        node-key="roleId"
                        :checked-keys="checkedRoleKeys"
                        class="menu-tree"
                ></el-tree>
                <template #footer>
                    <div style="text-align: center; width: 100%;">
                        <el-button @click="configRoleDialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="roleDialogSubmit">确定</el-button>
                    </div>
                </template>
            </el-dialog>

            <!-- 设置检车员弹窗 -->
            <el-dialog v-model="inspectorDialogVisible" title="设置检车员" width="480px" destroy-on-close>
                <div v-loading="inspectorLoading">
                    <!-- 选中的电脑端用户信息 -->
                    <div style="background-color: #ecf5ff; padding: 12px 16px; border-radius: 4px; margin-bottom: 10px;">
                        <div style="font-weight: bold; margin-bottom: 8px;">已选中用户</div>
                        <div>用户名：{{ selectedRow.userName }}</div>
                        <div>手机号：{{ selectedRow.phoneNumber }}</div>
                    </div>

                    <!-- 微信用户信息显示 -->
                    <el-divider content-position="left">微信账户信息</el-divider>
                    <div v-if="inspectorUserDetail" style="background-color: #f5f7fa; padding: 12px 16px; border-radius: 4px;">
                        <el-form label-width="80px" style="max-width: 100%;">
                            <el-form-item label="微信昵称">
                                {{ inspectorUserDetail.nickName || '-' }}
                            </el-form-item>
                            <el-form-item label="手机号">
                                {{ inspectorUserDetail.phone || '-' }}
                            </el-form-item>
                            <el-form-item label="当前身份">
                                <el-tag :type="inspectorCurrentStatus === 1 ? 'success' : (inspectorCurrentStatus === 3 ? 'warning' : 'info')">
                                    {{ inspectorCurrentStatus === 1 ? '检车员' : (inspectorCurrentStatus === 3 ? '核验员' : '普通用户') }}
                                </el-tag>
                            </el-form-item>
                            <el-form-item label="设置身份">
                                <el-select v-model="inspectorCurrentStatus" style="width: 100%">
                                    <el-option :label="'普通用户'" :value="0"></el-option>
                                    <el-option :label="'检车员'" :value="1"></el-option>
                                    <el-option :label="'核验员'" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div v-else style="background-color: #fef0f0; padding: 12px 16px; border-radius: 4px; color: #f56c6c;">
                        该用户无微信账户数据，无法设置检车员
                    </div>
                </div>
                <template #footer>
                    <div style="text-align: center; width: 100%;">
                        <el-button @click="inspectorDialogVisible = false">关闭</el-button>
                        <el-button
                            type="primary"
                            :disabled="!inspectorUserDetail"
                            @click="handleSaveInspectorStatus"
                        >保存设置</el-button>
                    </div>
                </template>
            </el-dialog>
        </template>
    </CommonList>
</template>

<script setup>
    import useRoleList from './userList.js';
    import { ref } from 'vue';
    const roleTreeRef = ref(null);
    const {
        searchForm,
        listRef,
        dialogVisible,
        dialogType,
        formRef,
        selectedRow,
        formData,
        formRules,
        Edit, Delete,
        handleSelectionChange,
        handleCurrentRowChange,
        handleEdit,
        handleDelete,
        handleSubmit,
        handleLoadList,
        handleReset,
        configuration,
        configRoleDialogVisible,
        roleTreeData,
        treeProps,
        roleDialogSubmit,
        checkedRoleKeys,
        // 公司相关
        allCompanyList,
        selectedCompanyId,
        selectedCompanyDetail,
        companySelectDialogVisible,
        tempSelectedCompanyId,
        openCompanySelectDialog,
        handleCompanySelect,
        handleUnbindCompany,
        cancelCompanySelectDialog,
        confirmCompanySelect,
        // 设置检车员相关
        inspectorDialogVisible,
        inspectorLoading,
        inspectorUserDetail,
        inspectorCurrentStatus,
        handleSetInspector,
        handleSaveInspectorStatus
    } = useRoleList(roleTreeRef);
</script>

<style>
    @import '../../../assets/css/util/base-list.css';

</style>
<style scoped>
    .menu-tree {
        max-height: 400px;
        overflow-y: auto;
        padding: 10px;
    }
</style>
